import React, { useContext } from 'react'
import { connect } from 'react-redux'
import { UiContext } from 'context/ui'

import style from './DashboardAccount.module.scss'

import { POPUPS_ID } from 'utils/constants'

import profileAvatar from 'i/icons/profile_avatar_new.svg'

const DashboardAccount = ({ user }) => {
  const { setActivePopupId } = useContext(UiContext)
  const userLink = `https://www.talkpro.com/${user?.channel_name}`

  return (
    <>
      <div className={style.dashboardAccount}>
         <div className={style.dashboardAccountContent}>
          <div className={style.dashboardAccountName}>{user?.user?.name}</div>
          <div
            className={style.dashboardAccountLink}
            onClick={() => {
              navigator.clipboard.writeText(userLink)
            }}
          >
            talkpro.com/
            {user?.location?.state?.channelName || user?.channel_name || 'xxxxxxx'}
          </div>
        </div>
        <div className={style.dashboardAccountAvatarWrap}>
          <button
            type="button"
            className={style.dashboardAccountAvatar}
            onClick={() => setActivePopupId(POPUPS_ID.profile)}
            aria-label="Open account settings"
          >
            {user?.photo ? (
              <img src={user?.photo} alt="" className={style.dashboardAccountAvatarIn} />
            ) : (
              <img
                src={profileAvatar}
                alt=""
                className={style.dashboardAccountAvatarIn}
              />
            )}
          </button>
        </div>
       
      </div>
    </>
  )
}

const mapStateToProps = ({ auth: { error, isPro, user, calls } }) => ({
  authError: error,
  calls,
  user,
  isPro,
})

export default connect(mapStateToProps)(DashboardAccount)
